module.exports = new __parcel__URL__("multi-layer.51c2107f.png").toString();